/**
 * React entry. Mounts <App /> equivalents — the QueryClientProvider
 * wraps the RouterProvider so every TanStack Query hook inside any
 * route can access the shared client.
 */

import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { ToastProvider } from './components/ToastProvider'
// i18n bootstrap — initializes i18next (lazy-loads namespace JSON via
// dynamic import, registers ICU + custom Intl formatters). Must run
// BEFORE the React tree renders so `useTranslation()` calls have an
// initialized instance to read from. The pre-paint script in index.html
// has already applied <html lang/dir> from localStorage so first paint
// reads correctly.
import './i18n'
import { queryClient } from './lib/query-client'
import { router } from './router'
import './styles/global.css'

const rootEl = document.getElementById('root')
if (!rootEl) {
  throw new Error('Root element #root not found in index.html')
}

createRoot(rootEl).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <RouterProvider router={router} />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
)
